import { useLocalStorage } from "@vueuse/core";

export const useImpersonateTenant = () => {

  const { isAdmin } = useAuth();

  const impersonateTenantId = useLocalStorage<string | null>('amv-connected_impersonated-tenant-id', null);

  return {
    impersonatedTenantId: readonly(impersonateTenantId),
    impersonateTenant (tenantId: string) {
      if (isAdmin.value) {
        impersonateTenantId.value = tenantId;
        window.location.reload();
      }
    },
    stopTenantImpersonation () {
      if (isAdmin.value) {
        impersonateTenantId.value = null;
        window.location.reload();
      }
    }
  }
}
